import React from 'react';
import PropTypes from 'prop-types';

export default function Certification({ certification }) {
    const {
        certification_name,
        received_from,
        year
    } = certification;

    return (
        <li>
            <p>{certification_name}</p>
            <p>{received_from} {year}</p>
        </li>
    );
}

Certification.propTypes = {
    certification: PropTypes.shape({
        certification_name: PropTypes.string,
        received_from: PropTypes.string,
        year: PropTypes.number
    })
};

Certification.defaultProps = {
    certification: {
        certification_name: '',
        received_from: '',
        year: 0
    }
};



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/Certifications/Certification.js